var MediaQueries;
(function (MediaQueries) {
    MediaQueries["GSMALL"] = "(min-width: 1024px)";
    MediaQueries["GXSMALL"] = "(min-width: 768px)";
    // GMEDIUM = '(min-width: 1280px)',
    MediaQueries["LARGE"] = "(min-width: 1280px)";
    MediaQueries["MEDIUM"] = "(min-width: 1024px) and (max-width: 1279px)";
    MediaQueries["NONE"] = "";
    MediaQueries["SMALL"] = "(min-width: 768px) and (max-width: 1023px)";
    MediaQueries["XSMALL"] = "(max-width: 767px)";
    // GLARGE = '',
    // XLARGE = '',
})(MediaQueries || (MediaQueries = {}));
export default MediaQueries;
//# sourceMappingURL=media-queries.js.map